__turbopack_context__.v({
  "ContractSection": "contract-module-scss-module__WtnqZq__ContractSection",
  "backgroundLayer": "contract-module-scss-module__WtnqZq__backgroundLayer",
  "contact_btn": "contract-module-scss-module__WtnqZq__contact_btn",
  "cta": "contract-module-scss-module__WtnqZq__cta",
});
